// Неполная редакция приказа: правки базы, которых нет в цепочке (`chain_gaps.py`).
// Без пометки редакция выглядит действующей, а в ней не хватает правок.

import type { QuotaChainGap } from '../api'
import { formatDay } from '../i18n/format'

type T = (key: string, vars?: Record<string, string | number>) => string

/** Сколько правок назвать поимённо; остальные — числом. */
export const GAPS_SHOWN = 5

/** «№ 22 от 24.01.2025, № 321 от 02.06.2025 и ещё 3». */
export function gapsLine(gaps: QuotaChainGap[], lang: string, t: T): string {
  const named = gaps.slice(0, GAPS_SHOWN)
    .map(g => t('quotas.gap', { no: g.no, date: formatDay(lang as never, g.date) }))
    .join(', ')
  const more = gaps.length - GAPS_SHOWN
  return more > 0 ? `${named} ${t('quotas.gapsMore', { count: more })}` : named
}
